export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: ComicCategory[] = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '热血战斗，激情澎湃的冒险故事' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默，笑料百出的欢乐日常' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜心动，青涩美好的恋爱物语' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空，异世界的奇幻冒险' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扑朔迷离，烧脑刺激的推理之旅' },
  { slug: 'richang', name: '日常', icon: 'ri-sun-line', description: '温馨治愈，平凡生活的美好瞬间' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来世界，科技与人性的碰撞' },
  { slug: 'wuxia', name: '武侠', icon: 'ri-sword-line', description: '江湖恩怨，快意恩仇的武林传奇' },
];